export const AG_GRID_LOCALE_EN = {
    contains: 'Contains',
    notContains: 'Not contains',
    startsWith: 'Starts with',
    endsWith: 'Ends with',
    equals: 'Equals',
    notEqual: 'Not equal',
    filterOoo: 'Filter...'
}